import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BBLWhatIs() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-264">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-265">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-266">
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-267">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-268">
              <img src="https://cdn.magicpatterns.com/uploads/3kHBGcAvBLQ11TEFmLfCyQ/bbl-procedure.jpg" alt="BBL Treatment Procedure" className="w-full h-full object-cover" data-id="element-269" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-270">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-271">
              WHAT IS BBL?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-272"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-273">
              <p data-id="element-274">
                BroadBand Light (BBL) therapy, an FDA-cleared anti-aging
                treatment, offers a safe solution for addressing sun damage,
                uneven skin texture, and fine lines and wrinkles. Unlike
                surgical procedures, BBL is a quick in-office treatment for skin
                rejuvenation.
              </p>
              <p data-id="element-275">
                Through short bursts of high-intensity light, BBL gently heats
                the upper skin layers, prompting skin cells to regenerate
                collagen, restoring a firmer, smoother complexion reminiscent of
                youth. Additionally, the light energy can minimize redness by
                targeting fine blood vessels and diminish excess melanin
                associated with sun damage.
              </p>
              <p data-id="element-276">
                BBL is particularly adept at addressing concerns like
                loose/crepey skin, pigmented lesions like age spots and
                freckles, and vascular lesions such as visible blood vessels,
                offering comprehensive skin rejuvenation.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}